module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "loading": _vm.searchRequest.loading,
      "box": "",
      "clearable": "",
      "hint": "Start typing a code or description",
      "label": "Search for a process code"
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mx-2"
  }, [_c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.resetSuggestionsDialog),
      callback: function($$v) {
        _vm.resetSuggestionsDialog = $$v
      },
      expression: "resetSuggestionsDialog"
    }
  }, [(_vm.resetSuggestionsDialog) ? _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.requests.setsuggestions,
      "message200": "Suggestions have been updated"
    },
    on: {
      "ok": function($event) {
        _vm.resetSuggestionsDialog = false
      }
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_vm._v("\n            Clear suggestions\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.resetSuggestionsDialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0 pt-1 caption"
  }, [_vm._v("\n            Don't suggest codes/prices from appointments before this date.\n            Use this if you have changed your pricing and no longer want suggestions with the old pricing\n          ")]), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "no-title": "",
      "flat": "",
      "full-width": ""
    },
    model: {
      value: (_vm.suggestionDate),
      callback: function($$v) {
        _vm.suggestionDate = $$v
      },
      expression: "suggestionDate"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.requests.setsuggestions.loading
    },
    on: {
      "click": _vm.setSuggestionDate
    }
  }, [_vm._v("\n              Update suggestions")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "pl-2 overline"
  }, [_vm._v("\n        Recently used "), (_vm.afterDate) ? [_vm._v("since " + _vm._s(_vm.afterDate))] : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "py-0",
    attrs: {
      "small": "",
      "label": "",
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.resetSuggestionsDialog = true
      }
    }
  }, [_vm._v("Reset suggestions\n        ")])], 2), _vm._v(" "), _vm._l((_vm.filteredSuggestions), function(code, index) {
    return _c('v-chip', {
      key: index,
      attrs: {
        "small": "",
        "label": ""
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(code)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(code.name))]), _vm._v(" \n        " + _vm._s(_vm.formatCurrency('ZAR', (parseFloat(code.price)))) + "\n      ")])
  }), _vm._v(" "), (_vm.filteredSuggestions && _vm.filteredSuggestions.length === 0) ? _c('div', {
    staticClass: "caption px-2"
  }, [_vm._v("\n        No codes to suggest based on your appointments\n        "), (_vm.afterDate) ? [_vm._v("after " + _vm._s(_vm.afterDate))] : _vm._e()], 2) : _vm._e()], 2), _vm._v(" "), (_vm.searchString && _vm.searchString.length > 0) ? _c('v-list', {
    attrs: {
      "dense": "",
      "two-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Search results")]), _vm._v(" "), _vm._l((_vm.searchResults), function(result) {
    return [_c('v-list-tile', {
      key: ("li-" + (result.id)),
      on: {
        "click": function($event) {
          return _vm.selectItem(result)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v(_vm._s(result.name))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(result.description))])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n            " + _vm._s(_vm.formatCurrency('ZAR', (parseFloat(result.discovery_rate)))) + "\n          ")])], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (result.id))
    })]
  }), _vm._v(" "), (_vm.searchResults && _vm.searchResults.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("No codes matched your query")])], 1) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1df87e11","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/ProcessCodePicker.vue
// module id = 1347
// module chunks = 9